import { render } from "./SpecialProjectsListPage.vue?vue&type=template&id=531c047d&ts=true"
import script from "./SpecialProjectsListPage.vue?vue&type=script&lang=ts"
export * from "./SpecialProjectsListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__